<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <!-- Subscription overlay -->
    <b-overlay
      :show="show"
      variant="transparent"
      :opacity="1"
      blur="3px"
    >
      <template v-slot:overlay>
        <div class="text-center">
          <p id="cancel-label">
            Please upgrade your subscription to activate this feature
          </p>
          <b-button
            ref="cancel"
            variant="primary"
            aria-describedby="cancel-label"
            @click="upgradeSubscription()"
          >
            Click here to upgrade
          </b-button>
        </div>
      </template>

      <!-- User Interface controls -->

      <b-row>
        <b-col md="9">
          <h4 class="font-weight-bold ml-1">Egenerklæringer</h4>
        </b-col>

        <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Search"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col>
      </b-row>

      <b-modal
        id="newVessel"
        title="Nytt fartøy"
      >
        <b-form-group label="Navn">
          <b-form-input
            v-model="declaration.name"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="IMO nummer">
          <b-form-input
            v-model="declaration.imo"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="MMSI nummer">
          <b-form-input v-model="declaration.mmsi"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Kallesignal"
          label-for="name-input"
          invalid-feedback="Kallesignal nummer er påkrevd"
        >
          <b-form-input
            id="name-input"
            v-model="declaration.callsign"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Type">
          <b-form-select
            v-model="declaration.type"
            :options="vesselOptions"
          ></b-form-select>
        </b-form-group>

        <b-form v-if="declaration.type == 'Avlusningsfartøy'">
          <label>Antall linjer</label>
          <b-form-select
            class="mr-3"
            v-model="declaration.fls.lines"
            :options="flsLinesOptions"
          ></b-form-select>
        </b-form>

        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              class="float-right"
              @click="newVessel()"
            >
              Opprett fartøy
            </b-button>

            <b-button
              variant="default"
              class="float-right mr-2"
              @click="closeModal()"
            >
              Avbryt
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- Main table element -->
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="declarations"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        empty-text="There are no declarations to show"
      >
        <template v-slot:table-caption>Total: {{ declarations.length | numeralFormat }} egenerklæringer
        </template>

        <template v-slot:cell(ordertitle)="data">
          {{ data.item.ordernumber }} - {{ data.item.customer }} ({{
            data.item.site
          }})
        </template>

        <template v-slot:cell(completed_date)="data">
          {{ $date(data.value).format("DD.MM.YYYY") }}
        </template>

        <template v-slot:cell(accepted_date)="data">
          {{ $date(data.value).format("DD.MM.YYYY") }}
        </template>
      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <br />

      <b-row> </b-row>

      <!-- Info modal -->
      <b-modal
        :id="infoModal.id"
        :title="infoModal.title"
        ok-only
        @hide="resetInfoModal"
      >
        <pre>{{ infoModal.content }}</pre>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";



export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      declaration: {
        details: {},
      },
      declarations: [],
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        { key: "ordertitle", label: "Ordre", sortable: true },
        { key: "vessel", label: "Fartøy", sortable: true },
        { key: "completed_date", label: "Fullført", sortable: true },
        { key: "accepted_by", label: "Godkjent av", sortable: true },
        { key: "accepted_date", label: "Godkjent dato", sortable: true },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "created",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      limit: 1000,
      vesselOptions: [
        { value: "Avlusningsfartøy", text: "Avlusningsfartøy" },
        { value: "Brønnbåt", text: "Brønnbåt" },
        { value: "Servicebåt", text: "Servicebåt" },
      ],

      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      show: false,
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumDeclarationsTotal() {
      return this.declarations.length;
    },
  },
  methods: {
    getDeclarations() {
      this.isLoading = true;
      var company = localStorage.getItem("company");

      axios
        .get(
          "https://api.eines-as.no/declarations?_sort=createdAt:DESC&_where[company]=" + company
        )
        .then((res) => {
          this.declarations = res.data;
          this.isLoading = false;
        });
    },
    newDeclarations() {
      this.declaration.company = localStorage.getItem("company");
      axios
        .post("https://api.eines-as.no/declarations/", this.declaration)
        .then((response) => {
          this.declarations.push(response.data);
          this.$bvModal.hide("newVessel");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    updateShips() {
      axios.get("https://api.eines-as.no/ships").then((res) => {
        this.ships = res.data;
      });
    },
    closeModal() {
      this.$bvModal.hide("newVessel");
    },
  },
  created: function () {
    this.getDeclarations();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>